<div [ngClass]="{'footer-item': !disabled, 'footer-item-disabled': disabled, 'footer-item-selected': selected }" (click)="_clicked()">
    <img [ngClass]="{'footer-icon': !disabled, 'footer-icon-disabled': disabled}" src="{{icon}}" />
    <span class="footer-button-text">
            {{text}}
    </span>

</div>